export default class SubMenuToggle {
  constructor(element) {
    let toggleClassName = element.getAttribute("data-toggle-class");
    let toggleBtnClassName = element.getAttribute("data-toggle-btn");

    let toggleBtn = element.getElementsByClassName(toggleBtnClassName);

    if (!toggleClassName || !toggleBtn) {
      return;
    }

    let toggle = function (e) {
      let target = this.nextElementSibling;
      let link = "";

      if (!target.classList.contains(toggleClassName)) {
        if ((link = this.previousElementSibling || link == "A")) {
          link.classList.add(toggleClassName);
        }
        target.classList.add(toggleClassName);
        this.classList.add(toggleClassName);
        this.removeAttribute("aria-hidden");
      } else {
        if ((link = this.previousElementSibling || link == "A")) {
          link.classList.remove(toggleClassName);
        }
        target.classList.remove(toggleClassName);
        this.classList.remove(toggleClassName);
        this.setAttribute("aria-hidden", true);
      }
    };

    for (var i = 0; i < toggleBtn.length; i++) {
      toggleBtn[i].addEventListener("click", toggle);
    }
  }
}
